import * as React from 'react'
import { confirmAlert } from 'react-confirm-alert'
import Confirm from '@src/components/common/confirm'

export interface ConfirmProps {
  title?: React.ReactNode
  message?: React.ReactNode
  onSuccess?: (onClose?: () => void) => void
  onCancel?: (onClose?: () => void) => void
  autoClose?: boolean
}

const confirm = ({
  title = 'Confirm',
  message = 'Are you sure?',
  onSuccess,
  onCancel,
  autoClose = true
}: ConfirmProps) =>
  confirmAlert({
    customUI: options => (
      <Confirm
        title={title}
        message={message}
        options={options}
        onSuccess={onSuccess}
        onCancel={onCancel}
        autoClose={autoClose}
      />
    )
  })

export default confirm
